import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { 
    Flex, HStack, Button, ButtonGroup, Text, Icon,
    Table, Thead, Tbody, Tr, Th, Td, TableContainer,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, useDisclosure, useToast
} from '@chakra-ui/react';
import { MdNoteAlt, MdDeleteForever } from 'react-icons/md';
import { FormattedDate, FormattedTime } from 'react-intl';
import { SUCCESS_STATUS, FAILED_STATUS } from '../../../constants'
import { apiLoadListPatientResult, apiDeleteAPatientResult } from '../../../redux/apis/PatientResultApis';
import { getPatientResultList, getPatientResultActionStatus, getPatientResultActionMsg } from '../../../redux/selectors';
import { clearPatientResultActionStatus } from '../../../redux/actions';
import AddEditPatientResultModal from './AddEditPatientResultModal';
import NoDataPage from '../../../components/NoData';
import { displayConfirmChoiceAlert } from "../../utils";

function PatientResultsHistoryModal({ 
    initialRef, isOpen, onClose, patientDetail, isAction, patientResultList, patientResultActionStatus, patientResultActionMsg,
    apiLoadListPatientResult, apiDeleteAPatientResult, clearPatientResultActionStatus 
}) {
    const addEditPatientResultModal = useDisclosure();
    const [ selectedPatientResultId, setSelectedPatientResultId ] = useState(0);
    const [ isDeleted, setIsDeleted ] = useState(false);
    const [ isOpenPatientResultModal, setIsOpenPatientResultModal ] = useState(false);
    const toast = useToast();

    useEffect(() => {
        apiLoadListPatientResult({ patient_id: patientDetail?.id });
    }, [patientDetail]);

    useEffect(() => {
        if(isOpenPatientResultModal) {
            apiLoadListPatientResult({ patient_id: patientDetail?.id });
            setIsOpenPatientResultModal(false);
        }
    }, [patientResultList]);

    useEffect(() => {
        if(isDeleted) {
            if(patientResultActionStatus === SUCCESS_STATUS) {
                toast({
                    description: patientResultActionMsg,
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                })
                clearPatientResultActionStatus();
            } 
            else if(patientResultActionStatus === FAILED_STATUS) {
                toast({
                    description: "Thao tác của bạn không thành công!",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                })
                clearPatientResultActionStatus();
            }
        }
        setIsDeleted(false);
    }, [patientResultActionStatus]);

    return (
        <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
            <ModalOverlay />
            <ModalContent maxW="1000px">
                <ModalHeader>
                    <Flex>LỊCH SỬ KHÁM BỆNH NHÂN <Text color="orange.500" whiteSpace="preserve">{` ${patientDetail?.name}`}</Text></Flex>
                </ModalHeader>
                <ModalCloseButton />

                <ModalBody>
                    <TableContainer width="100%" p={2}>
                        <Table variant="simple" size="sm" fontWeight="600">
                            <Thead>
                                <Tr bg="#EAF0F0">
                                    <Th></Th>
                                    <Th>BÁC SỸ KHÁM</Th>
                                    <Th>NGÀY KHÁM</Th>
                                    <Th>KẾT QUẢ KHÁM</Th>
                                    {/* <Th>ĐƠN THUỐC</Th>
                                    <Th>SỐ NGÀY <br />ĐIỀU TRỊ</Th>
                                    <Th>THỰC PHẦM KIÊNG</Th> */}
                                    <Th></Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {
                                    patientResultList.map((item, idx) => {
                                        return (
                                            <Tr key={item.id}>
                                                <Td>
                                                    {idx + 1}
                                                </Td>
                                                <Td>
                                                    { item.doctorDetail?.name }
                                                </Td>
                                                <Td>
                                                    { item.date_return && <FormattedDate value={item.date_return} /> }
                                                </Td>
                                                <Td>
                                                    <Flex flexDirection="row" flexWrap="wrap">
                                                        { 
                                                            item.results && Object.keys(item.results).map(key => (
                                                                // <Flex flexDirection="row" flexWrap="wrap" key={key} gap={2}>
                                                                <HStack key={key} spacing={2}>
                                                                    <Text>{`${key}:`}</Text>
                                                                    <Text fontSize="18px" whiteSpace="preserve">{`${item.results[key]}, `}</Text>
                                                                </HStack>
                                                                // </Flex>
                                                            ))
                                                        }
                                                    </Flex>
                                                </Td>
                                                {/* <Td>
                                                    { 
                                                        item.medicine_results && item.medicine_results.map((medicine_result, idx) => {
                                                            const { medicine_name, count, drink_morning, drink_afternoon, drink_night } = medicine_result;
                                                            return (
                                                                <Text key={`medicine-result-${idx}`}>
                                                                    {
                                                                        `Thuốc: ${medicine_name || ""}, Uống: ${count || ""}, 
                                                                        Sáng: ${drink_morning || ""}, Chiều: ${drink_afternoon || ""}, Tối: ${drink_night || ""}`
                                                                    }
                                                                </Text>
                                                            )
                                                        })
                                                    }
                                                </Td>
                                                <Td>
                                                    { item.cure_day }
                                                </Td>
                                                <Td>
                                                    <Flex gap={2}>
                                                        { 
                                                            item.food_avoid && item.food_avoid.map(item => (
                                                                <Text key={item.label}>{item.label},</Text>
                                                            ))
                                                        }
                                                    </Flex>
                                                </Td> */}
                                                <Td>
                                                    <Flex flexDirection="row" gap={2}>
                                                        <Button colorScheme='blue' size="sm" isDisabled={!isAction}
                                                            onClick={
                                                                () => {
                                                                    setSelectedPatientResultId(item.id);
                                                                    setIsOpenPatientResultModal(true);
                                                                    addEditPatientResultModal.onOpen();
                                                                }
                                                            }
                                                        >
                                                            <Icon boxSize={4} as={MdNoteAlt} marginRight="8px"/> 
                                                            <Text fontSize="14px">
                                                                CẬP NHẬP
                                                            </Text>
                                                        </Button>
                                                        <Button colorScheme='red' size="sm" isDisabled={!isAction}
                                                            onClick={
                                                                () => {
                                                                    displayConfirmChoiceAlert("Bạn có muốn xoá kết quả khám này không?", () => {
                                                                        setIsDeleted(true);
                                                                        apiDeleteAPatientResult({ id: item.id, payload: { is_active: false } });
                                                                    })
                                                                }
                                                            }
                                                        >
                                                            <Icon boxSize={4} as={MdDeleteForever} marginRight="8px"/> 
                                                            <Text fontSize="14px">
                                                                XOÁ
                                                            </Text>
                                                        </Button>
                                                    </Flex>
                                                </Td>
                                            </Tr>
                                        )
                                    })
                                }
                            </Tbody>
                        </Table>
                    </TableContainer>

                    {
                        patientResultList?.length === 0 && <NoDataPage  text="Hiện tại không có dữ liệu"/>
                    }
                </ModalBody>
            </ModalContent>
            {
                addEditPatientResultModal.isOpen &&
                <AddEditPatientResultModal 
                    isOpen={addEditPatientResultModal.isOpen} onClose={addEditPatientResultModal.onClose} 
                    patientResultId={selectedPatientResultId} patientDetail={patientDetail}
                />
            }
        </Modal>
    )
}

const mapStateToProps = (state) => {
    const patientResultList           =   getPatientResultList(state);
    const patientResultActionStatus   =   getPatientResultActionStatus(state);
    const patientResultActionMsg      =   getPatientResultActionMsg(state);

    return { patientResultList, patientResultActionStatus, patientResultActionMsg };
}

const mapDispatchToProps = (dispatch) => ({
    apiLoadListPatientResult:           payload => dispatch(apiLoadListPatientResult(payload)),
    apiDeleteAPatientResult:            payload => dispatch(apiDeleteAPatientResult(payload)),

    clearPatientResultActionStatus:     payload => dispatch(clearPatientResultActionStatus(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(PatientResultsHistoryModal);